import api from './api';

export const bookingService = {
  // Get all bookings (owner) — supports ?status=&payment_status=&room_id=&from_date=&to_date=
  getAllBookings: async (params = {}) => {
    return await api.get('/bookings', { params });
  },

  // Get my bookings (customer)
  getMyBookings: async () => {
    return await api.get('/bookings/my');
  },

  // Get bookings created by agent
  getAgentBookings: async () => {
    return await api.get('/bookings/agent');
  },

  // Create new booking (customer or agent)
  createBooking: async (bookingData) => {
    return await api.post('/bookings', bookingData);
  },

  // Get single booking by ID
  getBookingById: async (bookingId) => {
    return await api.get(`/bookings/${bookingId}`);
  },

  // Cancel booking (customer or owner)
  cancelBooking: async (bookingId) => {
    return await api.put(`/bookings/${bookingId}/cancel`);
  },

  // Update booking status (owner)
  updateBookingStatus: async (bookingId, booking_status) => {
    return await api.put(`/bookings/${bookingId}/status`, { booking_status });
  },

  // Update payment status (owner)
  updatePaymentStatus: async (bookingId, payment_status) => {
    return await api.put(`/bookings/${bookingId}/payment`, { payment_status });
  },
};